// removed by extract-text-webpack-plugin
module.exports = {"container":"_3jav","computer":"EIgw","straightComputer":"_2jy_","tiltedComputer":"BzuN","background":"_3SD4","tiltedBackground":"_3wCC","backgroundImageContainer":"_2kvG","straightBackground":"_369K"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/LandingPage/Hero/Previews/styles.scss
// module id = 313
// module chunks = 0